import React, { useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { convertDateString } from 'utils/helpers';

export const Alert = ({ alert, removeAlertFromSection, sectionId, index, disabled, setDisabled }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleRemoveAlertFromSection = () => {
        setIsLoading(true);

        if (!disabled[alert.id] || isLoading) {
            removeAlertFromSection(alert.id, sectionId, 0, 0, true)
            setDisabled((prev) => ({ ...prev, [alert.id]: true }));

            setTimeout(() => setDisabled((prev) => ({ ...prev, [alert.id]: false })), 3000)
        }

        setIsLoading(false);
    };

    return (
        <Draggable draggableId={String(alert.id)} index={index} type="alert">
            {(provided, snapshot) => (
                <div
                    className={'newsletter-section-alert ' + (snapshot.isDragging ? 'newsletter-section-alert--is-dragging' : '')}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}>
                    <div className="newsletter-section-alert__inner">
                        <span className="newsletter-section-alert__title">{alert.name}</span>

                        <span className="newsletter-section-alert__date">
                        {alert.source.contentUpdatedAt ? convertDateString(alert.source.contentUpdatedAt) : 'Pending Updates'}
                    </span>
                    </div>

                    <button className="newsletter-section-alert__unassign-btn" onClick={handleRemoveAlertFromSection}>
                        <span>×</span>
                    </button>
                </div>
            )}
        </Draggable>
    );
}
